var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAdBlocked && _vm.adBlockFallback && !_vm.disableAd)?_c('AdBlockFallback',{attrs:{"settings":_vm.adBlockFallback}}):_c('div',{staticClass:"C-banner",class:_vm.classModifier,attrs:{"id":_vm.idModifier}},[_c('div',{ref:`${_vm.adFormType}-${_vm.divId}`,attrs:{"id":_vm.uniqueIdentifier || _vm.divId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }